import { api } from './api';

export interface AssessmentAPI {
    id: string;
    company_id: string;
    name: string;
    description?: string;
    created_at: string;
    updated_at: string;
    modules?: AssessmentModule[];
    is_active: boolean;
    language: string;
    auto_analysis?: boolean;
    data_collection?: boolean;
}

export interface AssessmentModule {
    id: string;
    type: string;
    questionnaire_label?: string;
    questionnaire_type?:
        | 'no-scores'
        | 'count-category-scores'
        | 'average-scores'
        | 'summed-scores';
    categories?: { id: string; name: string }[];
    videos?: {
        low_res: string;
        high_res: string;
    };
    record_video?: boolean;
    questions?: {
        questionId: string;
        question: string;
        videos?: { low_res: string; high_res: string };
    }[];
    timer?: {
        perPage: boolean;
        time: number;
    };
    questionnaire?: {
        'en-US'?: any;
        'nl-NL'?: any;
    };
    modules?: unknown;
    customQuestionnaire?: string;
    customModuleLabel?: { 'nl-NL': string; 'en-US': string; 'fr-FR'?: string };
}

export const scanTemplates = api.injectEndpoints({
    endpoints: (builder) => ({
        getScanTemplates: builder.query<AssessmentAPI[], string>({
            query: (companyIdentifier) => ({
                url: `companies/${companyIdentifier}/assessments`,
                params: {
                    include_modules: true,
                },
            }),
            providesTags: (result, error, companyIdentifier) => [
                { type: 'ScanTemplate', companyIdentifier },
            ],
        }),

        getScanTemplate: builder.query<
            AssessmentAPI,
            { companyIdentifier: string; scanTemplateId: string }
        >({
            query: ({ companyIdentifier, scanTemplateId }) =>
                `companies/${companyIdentifier}/assessments/${scanTemplateId}`,
            providesTags: (result, error, { scanTemplateId }) => [
                { type: 'ScanTemplate', id: scanTemplateId },
            ],
        }),
    }),
});

export const {
    useGetScanTemplateQuery,
    useLazyGetScanTemplateQuery,
    useGetScanTemplatesQuery,
    useLazyGetScanTemplatesQuery,
    util: { getRunningQueriesThunk },
} = scanTemplates;

// Export the API slice for use in SSR (if needed)
export const { getScanTemplate } = scanTemplates.endpoints;
